import React from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';

import Head from '../../components/Head';
import ImageDetail from '../../components/Lookbook/Image/ImageDetail';
import query from '../../lib/queries/lookbook/image.graphql';
import withApollo from '../../lib/apollo';
import withQuery from '../../lib/withQuery';
import throw404 from '../../lib/throw404';
import throw403 from '../../lib/throw403';
import redirectRouteToDomain from '../../lib/redirectRouteToDomain';
import {
  lookbookDetailImageConfigurations,
} from '../../lib/imageConfigurations';

const ImageDetails = ({ data: { image }, error }) => {
  if (
    error?.graphQLErrors?.some(({ message }) => message === 'Access denied')
  ) {
    return throw403();
  }

  if (!image) {
    return throw404();
  }

  const { id, title, description } = image;

  return (
    <>
      <div />
      <Head
        title={`${title || 'Untitled'} - Worldwide Fashion Design Lookbook`}
        description={description || 'Share, Create, Inspire and Showcase design on the international network for fashion professionals. Upload your design here.'}
        subjectType="Image"
        subjectId={id}
      />
      <ImageDetail {...image} />
    </>
  );
};

ImageDetails.propTypes = {
  data: PropTypes.shape({
    image: PropTypes.shape({
      id: PropTypes.number,
      title: PropTypes.string,
      description: PropTypes.string,
      credits: PropTypes.string,
    }),
  }),
  error: PropTypes.shape({
    graphQLErrors: PropTypes.arrayOf(PropTypes.shape({
      message: PropTypes.string,
    })),
  }),
};

ImageDetails.defaultProps = {
  data: {},
  error: undefined,
};

export const ImageDetailsWithQuery = withQuery(ImageDetails);

const ImagePage = () => {
  const { query: { id } } = useRouter();

  return (
    <ImageDetailsWithQuery
      query={query}
      variables={{
        id: Number(id),
        imageConfigurations: lookbookDetailImageConfigurations,
      }}
      errorMessage="Error loading image"
      passErrors={['Access denied']}
    />
  );
};

ImagePage.getInitialProps = redirectRouteToDomain('lookbookImage');

export default withApollo(ImagePage);
